import { createAction } from '@reduxjs/toolkit';
import type { HeatMapStyle } from '~/_shared/types/heatmap/heatMap.enum';

export const heatmapFormInitialStyleSet = createAction(
  'HEATMAP_FORM/INITIAL_STYLE_SET',
  (style: HeatMapStyle | null) => ({ payload: { style } }),
);

export const heatmapFormReset = createAction('HEATMAP_FORM/RESET');
